import type { RoleRequirementsConfig, AuthPolicy } from '@seek/rr-caja';

import { COUNTRY } from 'src/app/shared/constants/configObjectProperties';
import { LANGUAGE_DEFAULT } from 'src/app/shared/constants/language';
import { getConfig } from 'src/app/utils/config';
import { getAuthenticationLevel, isProd } from 'src/app/utils/environment';

export const getRoleRequirementsConfig = (
  getToken: () => Promise<string | null>,
  advertiserId: string,
  language: string = LANGUAGE_DEFAULT,
): RoleRequirementsConfig => {
  const auth: AuthPolicy = {
    tokenProvider: getToken as () => Promise<string>,
    advertiserId,
  };

  const roleRequirementsConfig: RoleRequirementsConfig = {
    auth,
    brand: 'seek',
    // Temporary default country, till we investigate it further issue related to create questionnaire
    country: getConfig(COUNTRY) ?? 'AU',
    environment: isProd() ? 'prod' : 'dev',
    locale: language as RoleRequirementsConfig['locale'],
  };

  if (getAuthenticationLevel() === 'Mocked') {
    roleRequirementsConfig.dangerouslyUseFullUrl = 'http://localhost:8081';
  }

  return roleRequirementsConfig;
};
